// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__Jm-Ce","avatar":"Item_avatar__2Rpka","man":"Item_man__29kNd","position":"Item_position__2ZQuQ"};